export class ProfileDTO {

    firstName: string;

    lastName: string;

    email: string;

    phone: string;

    cellPhone: string;

    image: string;

}
